document.addEventListener('DOMContentLoaded', () => {
  const state = new WeakMap();

  function getState(wrapper) {
    if (state.has(wrapper)) return state.get(wrapper);

    const gallery = wrapper.querySelector('.custom-gallery-main');
    const images = wrapper.querySelectorAll('.custom-main-image');
    const thumbs = wrapper.querySelectorAll('.custom-thumb');
    const dotsWrap = wrapper.querySelector('.custom-gallery-dots');
    const dots = dotsWrap ? dotsWrap.querySelectorAll('.custom-gallery-dot') : [];
    const thumbsViewport = wrapper.querySelector('.thumbs-viewport');

    const s = { gallery, images, thumbs, dots, thumbsViewport, currentIndex: 0 };
    state.set(wrapper, s);
    return s;
  }

  function setActive(wrapper, index, options) {
    options = options || {};
    const s = getState(wrapper);
    if (!s.images.length) return;
    index = Math.max(0, Math.min(index, s.images.length - 1));
    s.currentIndex = index;

    s.images.forEach((img, i) => img.classList.toggle('active', i === index));
    s.thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === index));
    s.dots.forEach((dot, i) => dot.classList.toggle('active', i === index));

    if (options.scrollThumb && s.thumbs[index] && s.thumbsViewport) {
      s.thumbsViewport.scrollTo({
        top: s.thumbs[index].offsetTop - s.thumbsViewport.clientHeight / 2 + s.thumbs[index].clientHeight / 2,
        behavior: 'smooth',
      });
    }

    if (options.scrollMobile && s.images[index] && window.matchMedia('(max-width: 749px)').matches) {
      s.gallery.scrollTo({ left: s.images[index].offsetLeft, behavior: 'smooth' });
    }
  }

  function updateArrowState(wrapper) {
    const s = getState(wrapper);
    const prevBtn = wrapper.querySelector('.thumb-slider-nav:not(.right)');
    const nextBtn = wrapper.querySelector('.thumb-slider-nav.right');
    if (!s.thumbsViewport || !prevBtn || !nextBtn) return;
    // Visual-only boundary indicator — never use the native `disabled`
    // property here, since disabled buttons stop firing click events
    // entirely, including for delegated listeners.
    prevBtn.classList.toggle('at-boundary', s.thumbsViewport.scrollTop <= 0);
    nextBtn.classList.toggle(
      'at-boundary',
      s.thumbsViewport.scrollTop + s.thumbsViewport.clientHeight >= s.thumbsViewport.scrollHeight - 1
    );
  }

  // ===== Event delegation: works regardless of when elements appear in the DOM =====

  document.addEventListener('click', (e) => {
    const wrapper = e.target.closest('.custom-product-gallery');
    if (!wrapper) return;

    const thumb = e.target.closest('.custom-thumb');
    if (thumb) {
      const s = getState(wrapper);
      const index = Array.from(s.thumbs).indexOf(thumb);
      if (index > -1) setActive(wrapper, index, { scrollThumb: true, scrollMobile: true });
      return;
    }

    const dot = e.target.closest('.custom-gallery-dot');
    if (dot) {
      const s = getState(wrapper);
      const index = Array.from(s.dots).indexOf(dot);
      if (index > -1) setActive(wrapper, index, { scrollThumb: true, scrollMobile: true });
      return;
    }

    const navBtn = e.target.closest('.thumb-slider-nav');
    if (navBtn) {
      const s = getState(wrapper);
      if (!s.thumbsViewport) return;
      const isNext = navBtn.classList.contains('right');
      s.thumbsViewport.scrollBy({ top: isNext ? 220 : -220, behavior: 'smooth' });
      setTimeout(() => updateArrowState(wrapper), 300);
      return;
    }
  });

  // ===== Mobile: native scroll syncs dots/thumbs =====

  document.addEventListener(
    'scroll',
    (e) => {
      const gallery = e.target.closest && e.target.closest('.custom-gallery-main');
      if (!gallery) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const wrapper = gallery.closest('.custom-product-gallery');
      if (!wrapper) return;

      clearTimeout(gallery._scrollTimeout);
      gallery._scrollTimeout = setTimeout(() => {
        const width = gallery.clientWidth;
        if (!width) return;
        const index = Math.round(gallery.scrollLeft / width);
        setActive(wrapper, index, { scrollThumb: true });
      }, 100);
    },
    true // capture phase, since scroll events don't bubble
  );

  // ===== Mobile: explicit JS touch-swipe fallback =====
  // Guarantees swipe works even if some other stylesheet/script restricts
  // native touch scrolling (touch-action, overflow, etc.)

  document.querySelectorAll('.custom-gallery-main').forEach((gallery) => {
    const wrapper = gallery.closest('.custom-product-gallery');
    if (!wrapper) return;

    let startX = 0;
    let startY = 0;
    let isSwiping = false;

    gallery.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isSwiping = true;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchend',
      (e) => {
        if (!isSwiping) return;
        isSwiping = false;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;

        // Only treat as a swipe if horizontal movement dominates
        if (Math.abs(diffX) < 30 || Math.abs(diffX) < Math.abs(diffY)) return;

        const s = getState(wrapper);
        if (diffX > 0) {
          setActive(wrapper, s.currentIndex + 1, { scrollThumb: true, scrollMobile: true });
        } else {
          setActive(wrapper, s.currentIndex - 1, { scrollThumb: true, scrollMobile: true });
        }
      },
      { passive: true }
    );
  });

  // ===== Recalculate arrow disabled-state once everything (incl. images) has actually loaded =====

  function initArrowStates() {
    document.querySelectorAll('.custom-product-gallery').forEach((wrapper) => updateArrowState(wrapper));
  }

  window.addEventListener('load', initArrowStates);
  setTimeout(initArrowStates, 500);

  document.querySelectorAll('.thumbs-viewport').forEach((viewport) => {
    const wrapper = viewport.closest('.custom-product-gallery');
    if (!wrapper) return;
    viewport.addEventListener('scroll', () => {
      clearTimeout(viewport._t);
      viewport._t = setTimeout(() => updateArrowState(wrapper), 100);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(() => updateArrowState(wrapper)).observe(viewport);
    }
  });
});

/* ===========================
   PRODUCT IMAGE LIGHTBOX
=========================== */

const lightbox = document.getElementById("customLightbox");
const lightboxImg = lightbox.querySelector(".custom-lightbox-image");
const closeBtn = lightbox.querySelector(".custom-lightbox-close");
const prevBtn = lightbox.querySelector(".custom-lightbox-prev");
const nextBtn = lightbox.querySelector(".custom-lightbox-next");

let activeGallery = null;
let activeImages = [];
let activeIndex = 0;

/* ===== LIGHTBOX ZOOM ===== */
let isZoomed = false;
const ZOOM_LEVEL = 2.5;

function resetZoom() {
  isZoomed = false;
  lightboxImg.classList.remove('zoomed');
  lightboxImg.style.transform = '';
  lightboxImg.style.transformOrigin = '';
}

lightboxImg.addEventListener('click', function (e) {
  e.stopPropagation();

  if (!isZoomed) {
    const rect = lightboxImg.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    lightboxImg.style.transformOrigin = x + '% ' + y + '%';
    lightboxImg.style.transform = 'scale(' + ZOOM_LEVEL + ')';
    lightboxImg.classList.add('zoomed');
    isZoomed = true;
  } else {
    resetZoom();
  }
});

// Pan by moving the mouse while zoomed
lightbox.addEventListener('mousemove', function (e) {
  if (!isZoomed) return;
  const rect = lightbox.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;
  lightboxImg.style.transformOrigin = x + '% ' + y + '%';
});


function openLightbox(wrapper,index){

    activeGallery = wrapper;

    activeImages = Array.from(
        wrapper.querySelectorAll(".custom-main-image img")
    );

    activeIndex = index;

    updateLightbox();

    lightbox.classList.add("active");

    document.body.style.overflow="hidden";
}

function updateLightbox(){

    if(!activeImages.length) return;
    resetZoom();
    lightboxImg.src = activeImages[activeIndex].src;
}

function closeLightbox(){
    resetZoom();
    lightbox.classList.remove("active");
    document.body.style.overflow="";
}

function nextImage(){

    activeIndex++;

    if(activeIndex>=activeImages.length){
        activeIndex=0;
    }

    updateLightbox();

    setActive(activeGallery,activeIndex,{
        scrollThumb:true,
        scrollMobile:true
    });

}

function prevImage(){

    activeIndex--;

    if(activeIndex<0){
        activeIndex=activeImages.length-1;
    }

    updateLightbox();

    setActive(activeGallery,activeIndex,{
        scrollThumb:true,
        scrollMobile:true
    });

}

document.addEventListener("click",function(e){

    const image=e.target.closest(".custom-main-image img");

    if(!image) return;

    const wrapper=image.closest(".custom-product-gallery");

    const images=Array.from(wrapper.querySelectorAll(".custom-main-image img"));

    const index=images.indexOf(image);

    openLightbox(wrapper,index);

});

closeBtn.addEventListener("click",closeLightbox);

lightbox.addEventListener("click",function(e){

    if(e.target===lightbox){
        closeLightbox();
    }

});

nextBtn.addEventListener("click",nextImage);

prevBtn.addEventListener("click",prevImage);

document.addEventListener("keydown",function(e){

    if(!lightbox.classList.contains("active")) return;

    if(e.key==="Escape") closeLightbox();

    if(e.key==="ArrowRight") nextImage();

    if(e.key==="ArrowLeft") prevImage();

});


